module.exports = "<div class=\"modal-content help-modal\">\n  <form name=\"form\" novalidate class=\"css-form\">\n  </form>\n</div>\n\n<div class=\"modal-content help-modal\">\n<div class=\"css-form\">\n<div class=\"modal-body\" id=\"modal-body\">\n  <p>\n    <strong>Warning</strong>\n  </p>\n  <p>\n    It seems you opened more then one tab. It can distort report results. Please use only one tab simultaneously.\n  </p>\n  <div class=\"modal-footer\">\n    <button class=\"btn button-cancel\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n  </div>\n</div>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/warn-modal.html
// module id = 680
// module chunks = 0